module.exports = __webpack_public_path__ + "img/vartext5en.7f43a6d6.svg";